// Reducer for rediscover actions

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'


export const DefaultRediscoverState = {
  byGenre: {},
  byId: {},
  selectedGenre: null,
  selectedGenreNetwork: null
}

export const DefaultDiscoverState = {
  ...DefaultState
}

export const thumbnailDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultDiscoverState,
  actionRequest: ActionTypes.REQUEST_REDISCOVER_ENTITY_IMAGE,
  actionFailure: ActionTypes.REQUEST_REDISCOVER_ENTITY_IMAGE_FAILURE,
  actionReceive: ActionTypes.RECEIVE_REDISCOVER_ENTITY_IMAGE,
  actionInvalidate: ActionTypes.INVALIDATE_REDISCOVER_ENTITY_IMAGE
})

export const demographicsDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultDiscoverState,
  actionRequest: ActionTypes.REQUEST_REDISCOVER_GENRE_DEMO,
  actionFailure: ActionTypes.REQUEST_REDISCOVER_GENRE_DEMO_FAILURE,
  actionReceive: ActionTypes.RECEIVE_REDISCOVER_GENRE_DEMO,
  actionInvalidate: ActionTypes.INVALIDATE_REDISCOVER_GENRE_DEMO
})

export const demoSummaryDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultDiscoverState,
  actionRequest: ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_SUMMARY,
  actionFailure: ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_SUMMARY_FAILURE,
  actionReceive: ActionTypes.RECEIVE_DISCOVER_GENRE_DEMO_SUMMARY,
  actionInvalidate: ActionTypes.INVALIDATE_DISCOVER_GENRE_DEMO_SUMMARY
})

export const discoverNetworkDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultDiscoverState,
  actionRequest: ActionTypes.REQUEST_REDISCOVER_NETWORK_DETAILS,
  actionFailure: ActionTypes.REQUEST_REDISCOVER_NETWORK_DETAILS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_REDISCOVER_NETWORK_DETAILS,
  actionInvalidate: ActionTypes.INVALIDATE_REDISCOVER_NETWORK_DETAILS
})

export const thumbnail = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_REDISCOVER_ENTITY_IMAGE:
    case ActionTypes.RECEIVE_REDISCOVER_ENTITY_IMAGE:
    case ActionTypes.REQUEST_REDISCOVER_ENTITY_IMAGE_FAILURE:
    case ActionTypes.INVALIDATE_REDISCOVER_ENTITY_IMAGE:
      if (action.network) {
        return {
          ...state,
          [action.network]: thumbnailDetails(state.details, action)
        }
      } else {
        console.warn('Error in the action:', action)
        return state
      }
    case ActionTypes.REQUEST_REDISCOVER_GENRE_DEMO:
    case ActionTypes.RECEIVE_REDISCOVER_GENRE_DEMO:
    case ActionTypes.REQUEST_REDISCOVER_GENRE_DEMO_FAILURE:
    case ActionTypes.INVALIDATE_REDISCOVER_GENRE_DEMO:
      if (action.genre) {
        return {
          ...state,
          demographics: demographicsDetails(state.details, action)
        }
      } else {
        console.warn('Error in the action:', action)
        return state
      }
    case ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_SUMMARY:
    case ActionTypes.RECEIVE_DISCOVER_GENRE_DEMO_SUMMARY:
    case ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_SUMMARY_FAILURE:
    case ActionTypes.INVALIDATE_DISCOVER_GENRE_DEMO_SUMMARY:
      if (action.genre) {
        return {
          ...state,
          demoSummary: demoSummaryDetails(state.details, action)
        }
      } else {
        console.warn('Error in the action:', action)
        return state
      }
    default:
      return state
    }
}

export const rediscoverById = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_REDISCOVER_NETWORK_DETAILS:
    case ActionTypes.RECEIVE_REDISCOVER_NETWORK_DETAILS:
    case ActionTypes.REQUEST_REDISCOVER_NETWORK_DETAILS_FAILURE:
    case ActionTypes.INVALIDATE_REDISCOVER_NETWORK_DETAILS:
      return {
        ...state,
        rediscoverNetwork: discoverNetworkDetails(state.details, action)
      }
    default:
      return state
    }
}

export const rediscover = (state = DefaultRediscoverState, action) => {
  switch (action.type) {
    case ActionTypes.REDISCOVER_SELECTED_GENRE:
      return {
        ...state,
        selectedGenre: action.genre
      }
    case ActionTypes.REDISCOVER_SELECTED_GENRE_NETWORK:
      return {
        ...state,
        selectedGenreNetwork: action.network
      }
    case ActionTypes.REQUEST_REDISCOVER_ENTITY_IMAGE:
    case ActionTypes.RECEIVE_REDISCOVER_ENTITY_IMAGE:
    case ActionTypes.REQUEST_REDISCOVER_ENTITY_IMAGE_FAILURE:
    case ActionTypes.INVALIDATE_REDISCOVER_ENTITY_IMAGE:
    case ActionTypes.REQUEST_REDISCOVER_GENRE_DEMO:
    case ActionTypes.RECEIVE_REDISCOVER_GENRE_DEMO:
    case ActionTypes.REQUEST_REDISCOVER_GENRE_DEMO_FAILURE:
    case ActionTypes.INVALIDATE_REDISCOVER_GENRE_DEMO:
    case ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_SUMMARY:
    case ActionTypes.RECEIVE_DISCOVER_GENRE_DEMO_SUMMARY:
    case ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_SUMMARY_FAILURE:
    case ActionTypes.INVALIDATE_DISCOVER_GENRE_DEMO_SUMMARY:
      if (action.genre || action.network) {
        return {
          ...state,
          byGenre: {
            ...state.byGenre,
            [action.genre]: thumbnail(state.byGenre[action.genre], action)
          }
        }
      } else {
        console.warn('Error in the action:', action)
        return state
      }
    case ActionTypes.REQUEST_REDISCOVER_NETWORK_DETAILS:
    case ActionTypes.RECEIVE_REDISCOVER_NETWORK_DETAILS:
    case ActionTypes.REQUEST_REDISCOVER_NETWORK_DETAILS_FAILURE:
    case ActionTypes.INVALIDATE_REDISCOVER_NETWORK_DETAILS:
      if (action.topicId) {
        return {
          ...state,
          byId: {
            ...state.byId,
            [action.topicId]: rediscoverById(state.byId[action.topicId], action)
          }
        }
      } else {
        console.warn('Topic action fired without a topic id:', action)
        return state
      }
    default:
      return state
    }
}